import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ButtonWithSpinner from '../../../../components/buttons/ButtonWithSpinner';
import { usePrepareStudentGroups } from './AssignLessonActionWithDateSelectionHooks';
import CustomDialog from '../../../../components/dialog/CustomDialog';
import './AssignLessonActionWithDateSelectionV2.scss';
import NewVizzleIframe from '../../../../components/vizzle/container/NewVizzleIframe';
import { useDomain } from '../../../../states/AppDomainProvider';

import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  lessons: [],
  selectedLessonIds: [],
  buttonLabel: 'Assign',
  currentStudent: null,
  showAddToMyList: false,
  reloadDataFunc: () => { },
  tagNameForAutoSaving: null,
  objectiveType: undefined,
};

export default function AssignLessonActionWithDateSelectionV2(p) {
  const {
    lessons,
    selectedLessonIds,
    buttonLabel,
    currentStudent,
    showAddToMyList,
    reloadDataFunc,
    tagNameForAutoSaving,
    objectiveType,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { uiDomain } = useDomain();
  const [openDialog, setOpenDialog] = useState(false);

  const selectedLessons = [];
  lessons.forEach((l) => {
    if (selectedLessonIds.includes(l.id)) {
      selectedLessons.push(l);
    }
  });

  const handleOnClick = () => {
    setOpenDialog(true);
  };

  const handleOnDialogClose = () => {
    setOpenDialog(false);
  };

  const {
    loading,
    studentGroupData,
  } = usePrepareStudentGroups();

  useEffect(() => {
    const register = (e) => {
      const { data } = e;
      if (data.event === 'close-dialog') {
        handleOnDialogClose();
      } else if (data.event === 'save-activities-assigment-success') {
        reloadDataFunc();
      } else if (data.event === 'save-tags-assigment-success') {
        uiDomain.showSnackbar(true, 'success', 3000, 'Lessons tagged successfully');
        reloadDataFunc();
      }
    };
    window.addEventListener('message', register);

    return () => {
      window.removeEventListener('message', register);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ButtonWithSpinner
        variant='contained'
        className='btn-primary assign-lesson-action-v2-button'
        disabled={!selectedLessonIds || selectedLessonIds.length === 0}
        onClick={handleOnClick}
        startIcon={<PersonAddIcon />}
        data-test='assign-lessons-action'
        label={buttonLabel}
        loading={loading}
      />
      {(!selectedLessonIds || selectedLessonIds.length === 0) && (
        <Typography variant='h6' className='orange-title assign-lesson-action-v2-button-orange-title'>
          Select activities
        </Typography>
      )}

      {openDialog && (
        <CustomDialog
          className='lessons-assignment-v2-sortable-dialog'
          openDialog={openDialog}
          onClose={handleOnDialogClose}
          fullScreen
          // title={<strong>Assign</strong>}
          content={(
            <Box width='100%' height='100vh' overflow='hidden'>
              <NewVizzleIframe
                path='/interim-assign-lesson'
                payload={{
                  assignmentItems: selectedLessons,
                  buttonLabel,
                  currentStudent,
                  showAddToMyList,
                  // reloadDataFunc,
                  tagNameForAutoSaving,
                  objectiveType,
                  studentGroupData,
                }}
              />
            </Box>
          )}
          displayCloseIcon={false}
        // actions={actions}
        />
      )}
    </>
  );
}
